import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterJP3: any = null,
    sceneTextLeaveJP3: any = null;
export default function JP3() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const [gap, setGap] = useState(24);

    const cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/22_1.jpg',
            text: t('secJP3_card1_text'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/22_2.jpg',
            text: t('secJP3_card2_text'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/22_3.jpg',
            text: t('secJP3_card3_text'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 20 : 16);
            resize();
            //window?.addEventListener('resize', resize);
            //return () => window.removeEventListener('resize', resize);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterJP3) {
                    AniContainer.removeScene(sceneTextEnterJP3);
                    sceneTextEnterJP3 = null;
                }
                if (sceneTextLeaveJP3) {
                    AniContainer.removeScene(sceneTextLeaveJP3);
                    sceneTextLeaveJP3 = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterJP3 = AniContainer.create({
                    triggerElement: '.dpu-detail-JP3',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            return () => {
                if (sceneTextEnterJP3) {
                    AniContainer.removeScene(sceneTextEnterJP3);
                    sceneTextEnterJP3 = null;
                }
                if (sceneTextLeaveJP3) {
                    AniContainer.removeScene(sceneTextLeaveJP3);
                    sceneTextLeaveJP3 = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-JP3 dpu-detail-section ${css['dpu-detail-JP3']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h2 className="title">{t('secJP3_title')}</h2>
            </div>
            <Swiper className="cards swiper-box" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture src={`${card?.img}`} alt={card?.text} />
                        <p className={`card-text ${k === 1 ? 'black' : ''}`}>{card?.text}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
